import React, { FunctionComponent, ReactNode } from 'react';

import { makeStyles } from '@mui/styles'
import { Typography } from '@mui/material';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 16,
    fontWeight: 900,
    textAlign: 'left',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

type ToolCardFormProps = {
  label: string,
  actionLabel: string,
  disableForm: boolean,
  children?: ReactNode;

}

export const ToolCardMultiForm: FunctionComponent<ToolCardFormProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <Typography
        className={classes.title}
        color='textSecondary'
        gutterBottom
      >
        {props.actionLabel}
      </Typography>
      <form className={classes.form}>
        {props.children}
      </form>
    </>
  );
}